import React from 'react';
import { ArticleTitle } from '../../../../components/ArticleTitle';
import { CamelizedArticleResponse } from '../../../../types/api';
import { Typography } from '../../../../components/Typography';
import { Flex } from '../../../../wag-react/next-components/Flex';
export type DailyWagArticleHeaderProps = Pick<CamelizedArticleResponse, 'readTime'> & {
  title: string;
};
export const DailyWagArticleHeader = ({
  title,
  readTime
}: DailyWagArticleHeaderProps) => <Flex flexDirection={['column', null, 'column-reverse']} data-sentry-element="Flex" data-sentry-component="DailyWagArticleHeader" data-sentry-source-file="index.tsx">
    <Typography mb={[1, null, 3]} fontSize={['14px', null, '16px']} style={{
    textTransform: 'uppercase'
  }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {readTime && readTime.text}
    </Typography>
    <ArticleTitle color="#474747" data-sentry-element="ArticleTitle" data-sentry-source-file="index.tsx">
      {title}
    </ArticleTitle>
  </Flex>;